import React, { memo, useState } from 'react';
import { Col, Row } from 'reactstrap';
import moment from 'moment';

import CustomModal from '../../components/GeneralForm/CustomModal';
import MultiRoleDatePicker, { PICKERTYPE_DATE } from '../../components/GeneralForm/MultiRoleDatePicker';
import { showMsg } from '../../services/library';
import CommonService from '../../services/commonService';
import { DATE_FORMAT_YMD } from '../../constants/dateFormatsConst';

const PhotoReportModal = props => {
  let userData = (props && props?.user) || null;
  let dealerData = (props && props?.dealer) || null;

  const [fromDate, setFromDate] = useState(moment().toDate());

  // send report
  const handleInstantImportReport = async () => {
    props.handleLayoutLoader(true);
    try {
      const response = await CommonService.sendInstantPhotoReport({
        dealer_id: dealerData?.value,
        date: moment(fromDate).format(DATE_FORMAT_YMD)
      });
      if (response.status) {
        showMsg(response.message, 'success');
        props.toggle();
      } else {
        showMsg(response.errors, 'error');
      }
    } catch (error) {
      showMsg(error, 'error');
    } finally {
      props.handleLayoutLoader(false);
    }
  };

  return (
    <CustomModal
      isOpen={props.isOpen}
      closeClick={props.toggle}
      modalScrollable={false}
      modalSize="md"
      saveClick={handleInstantImportReport}
      submitButtonName="Send"
      modalTitle="Photo Report"
      modalBackDrop="static"
    >
      <div className="px-2 py-3">
        <div className=" p-3 bg-light">
          <Row className="mb-3">
            <Col sm="4">Recipient :</Col>
            <Col sm="8">{userData?.user_email || 'logged in user email'}</Col>
          </Row>

          <Row className="mb-3">
            <Col sm="4">Dealership :</Col>
            <Col sm="8">{dealerData?.label}</Col>
          </Row>
          <Row>
            <Col sm="4">Date :</Col>
            <Col sm="8">
              <MultiRoleDatePicker
                selected={fromDate}
                buttonIsOutline={false}
                isDateTextShown={true}
                onChange={date => {
                  const SelectedDate = moment(date).format(DATE_FORMAT_YMD);
                  setFromDate(SelectedDate);
                }}
                buttonIcon="fa-fw fa-envelope mr-2"
                pickerType={PICKERTYPE_DATE}
                buttonStyle={{
                  padding: '0.25rem 0.5rem 0.25rem 0.5rem'
                }}
              />
            </Col>
          </Row>
        </div>
      </div>
    </CustomModal>
  );
};

PhotoReportModal.displayName = 'PhotoReportModal';
export default memo(PhotoReportModal);
